{
    "name": "07  mushroom",
    "title": "MushroomPopper",
    "description": "MushroomPopperUpgradeDescription1",
    "stat": 73,
    "boughtEarlyStat": 75,
    "inventoryStat": 74,
    "lockFlag": 98
}
